import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class CwmCredsEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspCwmCreds),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/cwm/creds').pipe(
                    map((res) => actions.loadMspCwmCredsSuccess(res)),
                    catchError((error) => of(actions.loadMspCwmCredsFailure({ error }))),
                ),
            ),
        ),
    );

    create$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.createMspCwmCreds),
            mergeMap(({ data }) =>
                this.ajax.post<{ valid: boolean }>('/api/octiga/v3/msp/cwm/creds', data).pipe(
                    switchMap(({ valid }) =>
                        valid
                            ? this.ajax
                                  .get('/api/octiga/v3/msp/cwm/creds')
                                  .pipe(mergeMap((creds) => [actions.createMspCwmCredsSuccess({ data: creds.data })]))
                            : throwError(() => new Error('Invalid credentials')),
                    ),
                    catchError((error) => of(actions.createMspCwmCredsFailure({ error }))),
                ),
            ),
        ),
    );

    put$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.putMspCwmCreds),
            mergeMap(({ data }) =>
                this.ajax.put<{ valid: boolean }>('/api/octiga/v3/msp/cwm/creds', data).pipe(
                    switchMap(({ valid }) =>
                        valid
                            ? this.ajax
                                  .get('/api/octiga/v3/msp/cwm/creds')
                                  .pipe(mergeMap((creds) => [actions.putMspCwmCredsSuccess({ data: creds.data })]))
                            : throwError(() => new Error('Invalid credentials')),
                    ),
                    catchError((error) => of(actions.putMspCwmCredsFailure({ error }))),
                ),
            ),
        ),
    );

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.deleteMspCwmIntegration),
            mergeMap(() =>
                this.ajax.delete('/api/octiga/v3/msp/cwm').pipe(
                    map(() => actions.deleteMspCwmIntegrationSuccess()),
                    catchError((error) => of(actions.deleteMspCwmIntegrationFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
